import { defineMessages } from 'react-intl';
var messages = defineMessages({
    Add: {
        id: 'Add',
        defaultMessage: 'Add',
    },
    ShowWeekend: {
        id: 'ShowWeekend',
        defaultMessage: 'Show weekend',
    },
    WeekendTasksTooltip: {
        id: 'WeekendTasksTooltip',
        defaultMessage: '{count} task(s) in the weekend this week',
    },
    NewTask: {
        id: 'NewTask',
        defaultMessage: 'New task',
    },
    WeekPlanner: {
        id: 'WeekPlanner',
        defaultMessage: 'Week planner',
    },
    ForEmployee: {
        id: 'ForEmployee',
        defaultMessage: 'For employee',
    },
    SelectTask: {
        id: 'SelectTask',
        defaultMessage: 'Select task',
    },
    Status: {
        id: 'Status',
        defaultMessage: 'Status',
    },
    ExecutionDateFrom: {
        id: 'ExecutionDateFrom',
        defaultMessage: 'Execution date from',
    },
    ExecutionDateUntil: {
        id: 'ExecutionDateUntil',
        defaultMessage: 'Execution date until',
    },
    TaskTemplates: {
        id: 'TaskTemplates',
        defaultMessage: 'Task templates',
    },
    SubtractOneWeek: {
        id: 'SubtractOneWeek',
        defaultMessage: '-1 week',
    },
    CurrentWeek: {
        id: 'CurrentWeek',
        defaultMessage: 'Current week',
    },
    AddOneWeek: {
        id: 'AddOneWeek',
        defaultMessage: '+1 week',
    },
    WorkingTime: {
        id: 'WorkingTime',
        defaultMessage: 'Working time',
    },
    Planned: {
        id: 'Planned',
        defaultMessage: 'Planned',
    },
    Available: {
        id: 'Available',
        defaultMessage: 'Available',
    },
    Holiday: {
        id: 'Holiday',
        defaultMessage: 'Holiday',
    },
    CreateNewToDo: {
        id: 'CreateNewToDo',
        defaultMessage: 'Create new to-do',
    },
    PlanTasks: {
        id: 'PlanTasks',
        defaultMessage: 'Plan tasks',
    },
    UnplannedTasks: {
        id: 'UnplannedTasks',
        defaultMessage: 'Unplanned tasks',
    },
    NoUnplannedTasks: {
        id: 'NoUnplannedTasks',
        defaultMessage: 'No unplanned tasks found',
    },
    Filters: {
        id: 'Filters',
        defaultMessage: 'Filters',
    },
    OnlyTasksUserCanStart: {
        id: 'OnlyTasksUserCanStart',
        defaultMessage: 'Only tasks I can start working on',
    },
    OnlyTasksWithDuration: {
        id: 'OnlyTasksWithDuration',
        defaultMessage: 'Only tasks with a duration',
    },
    MainTask: {
        id: 'MainTask',
        defaultMessage: 'Main task',
    },
    SubTask: {
        id: 'SubTask',
        defaultMessage: 'Subtask',
    },
    SelectSubtask: {
        id: 'SelectSubtask',
        defaultMessage: 'Select subtask',
    },
    DeadlineFrom: {
        id: 'DeadlineFrom',
        defaultMessage: 'Deadline from',
    },
    DeadlineUntil: {
        id: 'DeadlineUntil',
        defaultMessage: 'Deadline until',
    },
    Relation: {
        id: 'Relation',
        defaultMessage: 'Relation',
    },
    ResetFilters: {
        id: 'ResetFilters',
        defaultMessage: 'Reset filters',
    },
    ClosePanel: {
        id: 'ClosePanel',
        defaultMessage: 'Close',
    },
});
export default messages;
